// gatsby-browser.js
// Initializes privacy-preserving PostHog analytics independently of consent.
// Google Analytics remains opt-in and is managed by @/utils/analytics.

import { initializeAnalytics, trackAnalyticsPageview } from '@/utils/analytics'

const isE2ETest = process.env.GATSBY_E2E_TEST === 'true'

// Gatsby calls this on the initial route and subsequent client-side navigation.
// PostHog records cookieless pageviews regardless of cookie consent; Google
// Analytics records pageviews only when the visitor has opted in.
export function onRouteUpdate() {
  trackAnalyticsPageview()
}

// Blog posts should always begin at their title when reached from a card or
// adjacent-post link, instead of restoring a prior reading position.
export function shouldUpdateScroll({ routerProps: { location } }) {
  if (location.pathname.startsWith('/resources/collins-blog/posts/')) {
    return [0, 0]
  }

  return true
}

// Initialize privacy-preserving PostHog even if the visitor hasn't made a
// cookie choice. This doesn't emit a pageview: onRouteUpdate handles that.
// Gatsby's document load event can precede React hydration; E2E tests wait
// for this test-only marker before exercising client-side interactions.
export function onInitialClientRender() {
  initializeAnalytics()

  if (isE2ETest) {
    document.documentElement.dataset.e2eHydrated = 'true'
  }
}
